import React from "react";

import { InternalButton } from "@sharedComponents/buttons";

import styles from "./main.module.scss";

type ShippingBannerProps = {
  title?: string;
  onClose: React.ComponentProps<typeof InternalButton>["onClick"];
  showAsBanner?: boolean;
};

const ShippingBanner: React.FC<ShippingBannerProps> = ({
  title = "All prices include shipping and basic decoration costs.",
  onClose,
  showAsBanner = true,
}) => {
  if (showAsBanner) {
    return (
      <div className={styles.shippingBannerWrap}>
        <div className={styles.shippingBanner}>
          {title}
          <InternalButton styleType="link" className={styles.iconClose} onClick={onClose} />
        </div>
      </div>
    );
  }
  return title;
};

export default ShippingBanner;
